import React from "react";
import styled from "styled-components";
import { buildPersonnelProfileUrl } from "../../util/ProfileLinkUtil";

const ProfileLink = styled.a`
    color: var(--blue);
    cursor: pointer;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

type PersonnelProfileNewTabLinkProps = {
    personnelId: number;
    children: React.ReactNode;
};

const PersonnelProfileNewTabLink: React.FC<PersonnelProfileNewTabLinkProps> = ({
    personnelId,
    children,
}) => (
    <ProfileLink
        href={buildPersonnelProfileUrl(personnelId)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={event => event.stopPropagation()}
    >
        {children}
    </ProfileLink>
);

export default PersonnelProfileNewTabLink;
